module.exports = __webpack_public_path__ + "img/Mickies_Pizzeria@2x.3544b22e.png";